var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855 4356 c-42 -18 -93 -79 -101 -121 -3 -19 -3 -52 1 -72 6 -34 184 -216 1688 -1720 1674 -1673 1682 -1682 1729 -1688 59 -9 108 7 147 47 40 41 55 88 46 146 -6 47 -15 56 -1678 1720 -920 919 -1686 1679 -1703 1687 -39 18 -89 19 -129 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372 3990 c-99 -8 -285 -35 -392 -58 -19 -4 -36 -14 -38 -22 -1 -8 76 -93 171 -188 l174 -174 39 11 c85 23 224 32 328 21 365 -37 667 -247 827 -575 58 -119 85 -216 99 -347 10 -101 1 -251 -21 -332 l-11 -39 305 -305 c300 -300 306 -305 329 -290 13 8 67 54 120 102 176 156 365 386 488 593 104 173 100 199 -66 448 -294 441 -711 780 -1204 977 -350 140 -778 206 -1148 178z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888 3388 c-89 -73 -271 -258 -351 -358 -80 -99 -201 -279 -246 -364 -58 -109 -44 -158 104 -381 291 -437 709 -778 1190 -970 326 -131 623 -187 980 -187 257 0 606 47 613 82 1 8 -76 93 -171 188 l-174 174 -39 -11 c-86 -23 -231 -32 -333 -21 -138 15 -228 42 -356 105 -320 158 -528 458 -565 815 -10 103 -1 252 21 333 l11 40 -304 304 c-166 166 -306 303 -310 303 -4 0 -35 -23 -70 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2621 3236 c-7 -9 80 -102 298 -320 237 -237 310 -304 318 -294 18 23 -14 145 -64 248 -93 191 -279 329 -495 369 -34 6 -51 5 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883 2498 c-18 -22 14 -145 63 -246 93 -190 281 -332 491 -370 38 -7 56 -6 62 2 7 9 -81 103 -298 320 -237 237 -310 304 -318 294z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/invisible.b539d294029fb4e9d2ec3cce75cfcc6e.svg";
export { ForwardRef as ReactComponent };